import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formate un nombre d'heures en format décimal français : 8,25h
 * @param {number} h - Heures en décimal (ex: 8.25)
 * @returns {string} - Format "8,25h"
 */
export function fmtHeures(h) {
  return (h || 0).toFixed(2).replace('.', ',') + 'h';
}
